import {
  OrderType,
  PlatformScenarioListOrderFields,
  Scenario_Status,
  useScenarioOptionsQuery,
} from "@generated/graphql";

const useGetScenarioOptions = () => {
  const { data, loading } = useScenarioOptionsQuery({
    fetchPolicy: "cache-and-network",
    variables: {
      filter: { status: Scenario_Status.Approved },
      limit: 1000,
      page: 0,
      order: { field: PlatformScenarioListOrderFields.CreatedAt, order: OrderType.Desc },
    },
  });

  return { scenariosOptions: data?.scenarios.data || [], loading };
};

export default useGetScenarioOptions;
